import React, { useState } from "react";
import SearchDropDown from "../common/SearchDropDown";
import { SEARCH_TYPE } from "../../constant";

export default function CandidateTypeSearch({val, setVal}) {
  const [value, setValue] = useState([]);

  return (
    <SearchDropDown
      mode="multiple"
      value={value}
      placeholder="All Candidate "
      onChange={(newValue) => {
        setValue(newValue);
      }}
      type={SEARCH_TYPE.CANDIDATE_TYPE}
      val={val}
      setVal={setVal}
      style={{
        width: "100%",
      }}
    />
  );
}
